<template>
  <div v-if="gatewayAvailable" class="col-12">
    <template v-if="!isLoading">
      <p class="content-title">Stripe</p>
      <div id="card-element" v-if="stripe_client_key">
        <div class="form-group">
          <label for="">Card Number</label>
          <div id="cardNumber"></div>
          <div :class="`invalid-feedback d-block`" id="invalidCardNumber">
            {{ errors.invalidCardNumber && errors.invalidCardNumber }}
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-md-6">
              <label for="">Expiry</label>
              <div id="cardExpiry"></div>
              <div :class="`invalid-feedback d-block`" id="invalidCardExpiry">
                {{ errors.invalidCardExpiry && errors.invalidCardExpiry }}
              </div>
            </div>
            <div class="col-md-6">
              <label for="">CVC</label>
              <div id="cardCvc"></div>
              <div :class="`invalid-feedback d-block`" id="invalidCardCvc">
                {{ errors.invalidCardCvc && errors.invalidCardCvc }}
              </div>
            </div>
          </div>
        </div>
        <div class="form-group mb-0 text-danger">
          {{ errors.stripe_submit_error && errors.stripe_submit_error }}
        </div>
        <div class="form-group">
          <span class="term-holder">
            By proceeding, I agree to all
            <a
              href="https://www.qspaceapp.com/terms-of-service/"
              target="_blank"
              :style="`color: ${primary}`"
            >
              Terms of Service.
            </a>
          </span>
        </div>
        <div class="form-group">
          <ActionButton
            :theme="{ primary, secondary, event, danger }"
            class="mb-20 w-auto ml-auto"
            label="Pay Now"
            style="padding: 15px 20px;"
            :disabled="isProcessing"
            v-if="!isProcessing"
            @customEvent="SubmitPayment"
          />
          <Spinner v-if="isProcessing" />
        </div>
      </div>
    </template>
    <Spinner v-else :theme="primary" />
  </div>
</template>

<style lang="scss">
.invalid-feedback {
  font-size: 12px !important;
}
.StripeElement {
  box-sizing: border-box;
  height: 40px;
  padding: 11px 14px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
.content-title {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 10px;
}
#card-element {
  .form-group {
    label {
      margin-bottom: 10px;
    }
    .term-holder {
      font-size: 14px;
      display: block;
      a {
        color: #00b3c1;
        text-decoration: none;
      }
    }
  }
}
</style>

<script>
import ActionButton from "@/components/ActionButton";
import Spinner from "@/components/Spinner";
import instance from "@/helpers/base";
import axios from "@/helpers/axios";
import _ from "lodash";

export default {
  components: {
    ActionButton,
    Spinner
  },
  props: {
    amount: {
      type: [String],
      default: "0"
    },
    currency: {
      type: [String],
      default: "PHP"
    },
    invoice: {
      type: [Object]
    }
  },
  data() {
    return {
      gatewayAvailable: false,
      isProcessing: false,
      isLoading: true,
      stripe_client_key: null,
      stripe: {},
      errors: {
        invalidCardNumber: null,
        invalidExpiry: null,
        invalidCvc: null,
        stripe_submit_error: null
      },
      style: {
        base: {
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "1rem",
          "::placeholder": {
            color: "#aab7c4"
          }
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      },
      stripeCreds: null
    };
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    },
    options() {
      return this.$store.state.concierge.optionsList.data;
    }
  },
  async mounted() {
    await this.checkGatewayAvailability();
  },
  methods: {
    async checkGatewayAvailability() {
      await this.$store.dispatch("fetchOptions", "paymentoption");
      let result = _.filter(this.options, ["label", "Stripe"])[0];
      this.gatewayAvailable = !!result;
      this.stripeCreds = _.filter(result.value.data, ["status", true])[0];
      if (result) {
        await this.checkIfAvailable();
      }
      if (window.Stripe) {
        await this.setStripePublishable();
        if (this.stripe_client_key) {
          this.createCardElementInstance();
        }
      }
    },
    async checkIfAvailable() {
      this.isLoading = true;
      const orders = this.invoice.OrderPackages;
      var isavailable = true;
      for (var order of orders) {
        const id = order.Package.productId;
        await axios
          .get(
            `/products/${id}/availability?qp[start]=${order.startAt}&qp[end]=${order.endAt}&qp[op]=${order.id}`
          )
          .then(response => {
            const available = response.data.available;
            if (available === false) {
              isavailable = false;
            }
          });
      }
      this.showPaypal = isavailable;
      this.isLoading = false;
    },
    async setStripePublishable() {
      // let keys = this.options.find(i => i.value.status == true);
      let keys = this.stripeCreds;
      this.stripe_client_key = keys ? keys.value[0].value : null;
    },
    async createCardElementInstance() {
      // eslint-disable-next-line no-undef
      this.stripe.Instance = Stripe(this.stripe_client_key);
      const elements = this.stripe.Instance.elements();

      this.stripe.cardNumber = elements.create("cardNumber", {
        style: this.style
      });
      this.stripe.cardExpiry = elements.create("cardExpiry", {
        style: this.style
      });
      this.stripe.cardCvc = elements.create("cardCvc", { style: this.style });

      await this.stripe.cardNumber.mount("#cardNumber");
      await this.stripe.cardExpiry.mount("#cardExpiry");
      await this.stripe.cardCvc.mount("#cardCvc");

      this.stripe.cardNumber.addEventListener("change", event => {
        this.errors.invalidCardNumber = event.error
          ? event.error.message
          : null;
      });

      this.stripe.cardExpiry.addEventListener("change", event => {
        this.errors.invalidCardExpiry = event.error
          ? event.error.message
          : null;
      });

      this.stripe.cardCvc.addEventListener("change", event => {
        this.errors.invalidCardCvc = event.error ? event.error.message : null;
      });
    },
    SubmitPayment() {
      let description = `Booking payment from QSpace App.
      Reference Invoice #: ${this.invoice.code}`;
      this.isProcessing = true;
      this.stripe.Instance.createToken(this.stripe.cardNumber).then(result => {
        if (result.error) {
          this.errors.stripe_submit_error = result.error.message;
          for (let error in this.errors) {
            if (this.errors[error] == result.error.message) {
              this.errors.stripe_submit_error = null;
            }
          }
          this.isProcessing = false;
        } else {
          this.errors.stripe_submit_error = null;
          let request = {
            amount: this.invoice.totalAmount + "00",
            currency: "php",
            description,
            receipt_email: this.invoice.User.email,
            source: result.token.id,
            metadata: {
              customerForm: {
                name:
                  this.invoice.User.firstName +
                  " " +
                  this.invoice.User.lastName,
                email: this.invoice.User.email
              }
            }
          };
          instance
            .post("/payment/stripe/charge", request)
            .then(async val => {
              this.isProcessing = false;
              if (val.status == 200) {
                await this.$emit("approved", {
                  paymentType: "Stripe",
                  response: val && val.data
                });

                this.$swal({
                  title: "Payment Successful",
                  text: "Please check your email for transaction details.",
                  type: "success"
                });
              }
            })
            .catch(err => {
              this.isProcessing = false;
              if (err) {
                console.error(err);
                this.$swal({
                  title: "Something went wrong",
                  type: "warning"
                });
              }
            });
        }
      });
    }
  }
};
</script>
